import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import SiteChrome from "./components/Chrome/SiteChrome";
import DashboardPage from "./pages/dashboard/DashboardPage";
import BlogPage from "./pages/blog/BlogPage";
import BlogPost1 from "./components/blogs/BlogPost1";
import BlogPost2 from "./components/blogs/BlogPost2";
import BlogPost3 from "./components/blogs/BlogPost3";
import BlogPost4 from "./components/blogs/BlogPost4";
import BlogPost5 from "./components/blogs/BlogPost5";
import BlogPost6 from "./components/blogs/BlogPost6";
import ContactPage from "./components/Dashboard/ContactPage";
import TermsPage from "./pages/termscondition/TermsPage";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";
import AboutPage from "./pages/about/AboutPage";
import ServicesPage from "./pages/services/ServicesPage";
import TeamPage from "./pages/team/TeamPage";
import StrategiesPage from "./pages/strategies/StrategiesPage";
import MutualFundsPage from "./pages/mutual-funds/MutualFundsPage";
import BondsPage from "./pages/bonds/BondsPage";
import UnlistedSharesPage from "./pages/unlisted-shares/UnlistedSharesPage";
import IpoAdvisoryPage from "./pages/ipo/IpoAdvisoryPage";
import AlgoTradingPage from "./pages/algo-trading/AlgoTradingPage";
import BusinessServicesPage from "./pages/business/BusinessServicesPage";
import InsurancePage from "./pages/insurance/InsurancePage";
import LearningCentrePage from "./pages/learning/LearningCentrePage";
import PortfolioReviewPage from "./pages/portfolio-review/PortfolioReviewPage";
import CalculatorsPage from "./pages/calculators/CalculatorsPage";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/strategies" element={<StrategiesPage />} />
        <Route path="/mutual-funds" element={<MutualFundsPage />} />
        <Route path="/bonds" element={<BondsPage />} />
        <Route path="/unlisted-shares" element={<UnlistedSharesPage />} />
        <Route path="/ipo-advisory" element={<IpoAdvisoryPage />} />
        <Route path="/algo-trading" element={<AlgoTradingPage />} />
        <Route path="/business-services" element={<BusinessServicesPage />} />
        <Route path="/insurance" element={<InsurancePage />} />
        <Route path="/learning-centre" element={<LearningCentrePage />} />
        <Route path="/portfolio-review" element={<PortfolioReviewPage />} />
        <Route path="/calculators" element={<CalculatorsPage />} />
        <Route path="/blogs" element={<BlogPage />} />
        <Route
          path="/blog/a-guide-to-mastering-investment-tracking"
          element={<BlogPost1 />}
        />
        <Route
          path="/blog/start-planning-for-retirement-today"
          element={<BlogPost2 />}
        />
        <Route
          path="/blog/regain-control-with-debt-management"
          element={<BlogPost3 />}
        />
        <Route
          path="/blog/optimizing-strategies-for-financial-growth"
          element={<BlogPost4 />}
        />
        <Route
          path="/blog/stay-informed-with-real-time-updates"
          element={<BlogPost5 />}
        />
        <Route
          path="/blog/diversify-and-prosper-with-portfolio-management"
          element={<BlogPost6 />}
        />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
      <SiteChrome />
    </BrowserRouter>
  );
}

export default App;
